export class ResponseExampleSection {
  constructor (private readonly container: HTMLElement) {}

  update (example: unknown): void {
    const jsonPreview = this.container.querySelector('#jsonPreview') as HTMLElement

    if (example != null && jsonPreview != null) {
      this.container.classList.remove('hidden')
      jsonPreview.textContent = JSON.stringify(example, null, 2)
    } else {
      this.container.classList.add('hidden')
      jsonPreview.textContent = ''
    }
  }
}
